import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { selectContentTotalLength } from '../../selectors/ContentSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { AllCollectionsSpace, AllCollectionsSpaceDispatchProps, AllCollectionsSpaceOwnProps, AllCollectionsSpaceStateProps } from './AllCollectionsSpace';
import { createNoNameCollectionAction } from '../../actions/spaces/ContentExplorerCreateActions';

const mapStateToProps: MapStateToProps<AllCollectionsSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedCollections: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllCollectionsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  createNoNameCollection: createNoNameCollectionAction
}, dispatch);

export const ConnectedAllCollectionsSpace: React.ComponentClass<AllCollectionsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllCollectionsSpace);
